function normalizeBaseUrl(baseUrl) {
	if (!baseUrl) {
		if (typeof window !== "undefined" && window.location?.origin) {
			return window.location.origin;
		}
		return "";
	}

	return String(baseUrl).replace(/\/+$/, "");
}

export function buildApiDownloadUrl(resourcePath) {
	const normalizedPath = String(resourcePath || "").startsWith("/")
		? String(resourcePath)
		: `/${String(resourcePath || "")}`;

	const baseUrl = normalizeBaseUrl(import.meta.env.VITE_API_URL);
	if (!baseUrl) return normalizedPath;

	return `${baseUrl}${normalizedPath}`;
}

export function triggerBrowserDownload(resourcePath) {
	if (typeof document === "undefined") {
		throw new Error("Download non disponibile in questo ambiente");
	}

	const anchor = document.createElement("a");
	anchor.href = buildApiDownloadUrl(resourcePath);
	anchor.style.display = "none";
	document.body.appendChild(anchor);
	anchor.click();
	anchor.remove();
}
